import React, { useEffect, useState } from "react";

import { ParticipantTypes, useIsAbnRegisteredQuery } from "@api/graphql";
import { ToastMessage } from "@components/ToastMessage";
import { Loading } from "@components/loading";
import { validateABN } from "@pages/register/hooks/errorResolver";
import { useRegisterFormContext } from "@pages/register/hooks/useRegisterFormContext";

import { BusinessTaxDetailsForm } from "./BusinessTaxDetailsForm";

import styles from "./index.module.scss";

export const BusinessTaxDetails = ({
  isCreatedUserCompletingRegistration,
}: {
  isCreatedUserCompletingRegistration?: boolean;
}) => {
  const {
    control,
    errors,

    isJoiningExistingAccount,
    watch,
    isRoyaltyRecipientOnly,
    handleAbnRegistrationStatus,
    setValue,
    multiFormData,
  } = useRegisterFormContext();

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const abn = watch("tax_details.abn_acn");
  const isAbnValid = abn ? validateABN(abn) : false;

  const { data, loading, error } = useIsAbnRegisteredQuery({
    variables: {
      input: { abn: abn || "", user_role: multiFormData.user_role },
    },
    skip: !abn || !isAbnValid || isCreatedUserCompletingRegistration,
  });
  const message = data?.isAbnRegistered?.message;

  useEffect(() => {
    if (data?.isAbnRegistered?.success) {
      setValue("tax_details.legal_entity_name", data?.isAbnRegistered?.legal_entity_name);
      handleAbnRegistrationStatus(true);
    } else {
      handleAbnRegistrationStatus(false);
    }
  }, [data, handleAbnRegistrationStatus, setValue]);

  useEffect(() => {
    if (error) {
      setToastMessage(error?.message);
      setShowToast(true);
    } else {
      setToastMessage("");
      setShowToast(false);
    }
  }, [error]);

  const isBeneficiary = multiFormData.participant_type.includes(ParticipantTypes.BENEFICIARY);
  const isArtist = multiFormData.participant_type.includes(ParticipantTypes.ARTIST);
  const isCMO = multiFormData.participant_type.includes(ParticipantTypes.CMO);
  const isAMP = multiFormData.participant_type.includes(ParticipantTypes.AMP);
  const isArtCentre = multiFormData.participant_type.includes(ParticipantTypes.ART_CENTRE);
  return (
    <div className={styles["form-section"]}>
      <ToastMessage message={toastMessage} show={showToast} setShow={setShowToast} type="error" />
      {loading && <Loading />}
      {/* Use the BusinessTaxDetailsForm and pass the necessary props */}
      <BusinessTaxDetailsForm
        control={control}
        errors={errors}
        isJoiningExistingAccount={isJoiningExistingAccount}
        isRoyaltyRecipientOnly={isRoyaltyRecipientOnly}
        abnMessage={message}
        isArtist={isArtist}
        isBeneficiary={isBeneficiary}
        isAMP={isAMP}
        isCMO={isCMO}
        isArtCentre={isArtCentre}
      />
    </div>
  );
};
